import React, { CSSProperties, useEffect, useState } from "react";

import { Button, Divider, Form, Input, InputProps } from "semantic-ui-react";

import { toast } from "react-toastify";

import { useIntl } from "react-intl";

import PasswordRecheck from "react-lib/apps/common/PasswordRecheck";

// import EmailLoginManager from "react-lib/apps/IsHealth/Common/EmailLogin/EmailLoginManager";
import FacebookLoginButton from "react-lib/apps/IsHealth/Common/FacebookLogin/FBLoginButton";
import GoogleLoginButton from "react-lib/apps/IsHealth/Common/GoogleLogin/GoogleLoginButton";
import LineLoginManager from "react-lib/apps/IsHealth/Common/Line/LineLoginManager";
import LineLoginButton from "react-lib/apps/IsHealth/Common/Line/LoginButton";

import { getDeviceIdAndUserSubScription } from "./sequence/GetUserSubScription";

import CONFIG from "config/config";

declare global {
  interface Window {
    FB: any;
    fbAsyncInit: () => void;
  }
}

type LoginFormProps = {
  setProp: (key: string, value: any, callback?: () => void) => any;
  controller: any;
  AppInitializeSequence: any;
  loadingLogin?: boolean;

  facebookLogin?: (name: string) => void;
  // onEmailRegister: (email: string) => void;
  // onEmailSuccess: (email: string) => void;
  onLoginLoading?: (loading: boolean) => void;
  onLoginSubmit: () => void;
  onLoginSuccess?: (res: any) => void;

  // config
  isMeHey?: boolean;
};

const IMAGES = {
  facebook: "/static/images/landing/facebook-icon.png",
  line: "/static/images/landing/line-icon.png",
} as const;

type Styles = Record<
  "errorMessage" | "loginButton" | "mehayLoginButton" | "loginButtonsContainer",
  CSSProperties
>;

const styles: Styles = {
  errorMessage: {
    alignItems: "center",
    backgroundColor: "#fff1f0",
    border: "1px solid #ffccc7",
    borderRadius: "8px",
    color: "#cf1322",
    display: "flex",
    fontSize: "13px",
    marginTop: "8px",
    padding: "12px 16px",
  },
  loginButton: {
    background: "transparent",
    border: "1px solid #D9D9D9",
    borderRadius: "10px",
    color: "#2B2B2B",
    display: "flex",
    fontSize: "14px",
    marginBottom: "16px",
    padding: "6px 25px",
    whiteSpace: "nowrap",
  },
  loginButtonsContainer: {
    marginBottom: "1.4rem",
  },
  mehayLoginButton: {
    background: "liner-gradient(90deg, #FDA0B8, #F9C26F)",
    color: "inherit",
    border: "none",
  },
};

const LoginForm: React.FC<LoginFormProps> = (props) => {
  // const [email, setEmail] = useState<string>("");
  // const [emailError, setEmailError] = useState<string>("");
  // const [isEmailLoading, setIsEmailLoading] = useState<boolean>(false);

  const intl = useIntl();

  const lineLoginManager = new LineLoginManager();
  // const emailManager = new EmailLoginManager();

  const handleLineLogin = () => {
    void lineLoginManager.openLogin();
  };

  // const handleEmailChange = (e: any, data: InputProps): void => {
  //   setEmail(String(data.value));

  //   if (emailError) {
  //     setEmailError("");
  //   }
  // };

  const handleUsernameChange = (e: any, data: InputProps): void => {
    props.setProp("AppInitializeSequence.username", String(data.value));
  };

  // const handleEmailSubmit = async () => {
  //   setIsEmailLoading(true);

  //   try {
  //     await emailManager.requestLogin(email);

  //     setIsEmailLoading(false);

  //     props.onEmailSuccess(email);
  //   } catch (error: any) {
  //     setIsEmailLoading(false);

  //     if (error.response?.status === 404) {
  //       props.onEmailRegister(email);

  //       return;
  //     }

  //     setEmailError(
  //       JSON.stringify(
  //         error.response?.data?.email?.[0] || error.response?.data?.detail || error.response?.data
  //       )
  //     );
  //   }
  // };

  const handleResponseGoogle = async (data: any) => {
    console.log("handleResponseGoogle data:", data);

    props.onLoginLoading?.(true);

    const [deviceId, subscription] = await getDeviceIdAndUserSubScription(true);

    const postData = {
      app: CONFIG.APP_NAME,
      device_id: deviceId,
      code: data.code,
      subscription,
      callbackUrl: "postmessage",
    };

    let [response, error] = await props.controller.postRegisterByTokenGoogle(postData);

    if (error?.non_field_errors?.[0]?.includes("already registered")) {
      [response, error] = await props.controller.postRegisterByTokenGoogleConnect(postData);
    }

    if (response) {
      props.onLoginSuccess?.({ ...response, type: "google" });
    } else {
      toast.error("เข้าสู่ระบบไม่สำเร็จ");
    }

    props.onLoginLoading?.(false);
  };

  const handleResponseFacebook = async ({ data, deviceId, fbResponse, subscription }: any) => {
    const postData = {
      accessToken: fbResponse.authResponse?.accessToken,
      app: CONFIG.APP_NAME,
      device_id: deviceId,
      subscription,
    };

    let [response, error] = await props.controller.postRegisterByTokenFacebook(postData);

    if (error?.non_field_errors?.[0]?.includes("already registered")) {
      [response, error] = await props.controller.postRegisterByTokenFacebookConnect(postData);
    }

    if (response) {
      props.facebookLogin?.(data.name);
      props.onLoginSuccess?.({ ...response, type: "facebook" });
    } else {
      toast.error("เข้าสู่ระบบไม่สำเร็จ");
    }
  };

  return (
    <>
      <div style={styles.loginButtonsContainer}>
        {CONFIG.PENTA_ACC_LINE_LOGIN && (
          <LineLoginButton
            style={styles.loginButton}
            lineLoginText={intl.formatMessage({ id: "เข้าสู่ระบบด้วย LINE" })}
            logoSrc={IMAGES.line}
            logoStyle={{ height: "36px" }}
            spanStyle={{ marginLeft: "-30px" }}
            shimmer
            onClick={handleLineLogin}
            textStyle={{
              fontSize: "14px",
              margin: "auto",
            }}
          />
        )}

        {CONFIG.PENTA_ACC_LINE_LOGIN &&
          [CONFIG.PENTA_ACC_FACEBOOK_LOGIN, CONFIG.PENTA_ACC_GOOGLE_LOGIN].filter(Boolean)
            .length === 1 &&
          !CONFIG.PENTA_ACC_EMAIL_LOGIN && (
            <Divider style={{ margin: "2.5rem 0" }} horizontal>
              <div style={{ color: "#666", fontSize: "15px" }}>หรือ</div>
            </Divider>
          )}

        {CONFIG.PENTA_ACC_FACEBOOK_LOGIN && (
          <FacebookLoginButton
            style={styles.loginButton}
            appId="1782946359024414"
            fbLoginText={intl.formatMessage({ id: "เข้าสู่ระบบด้วย Facebook" })}
            logoSrc={IMAGES.facebook}
            logoStyle={{ height: "36px" }}
            version="v23.0"
            shimmer
            onCallback={handleResponseFacebook}
            onLoading={props.onLoginLoading}
            textStyle={{
              fontSize: "14px",
              margin: "auto",
            }}
          />
        )}

        {!CONFIG.PENTA_ACC_LINE_LOGIN &&
          CONFIG.PENTA_ACC_FACEBOOK_LOGIN &&
          CONFIG.PENTA_ACC_GOOGLE_LOGIN &&
          !CONFIG.PENTA_ACC_EMAIL_LOGIN && (
            <Divider style={{ margin: "2.5rem 0" }} horizontal>
              <div style={{ color: "#666", fontSize: "15px" }}>หรือ</div>
            </Divider>
          )}

        {CONFIG.PENTA_ACC_GOOGLE_LOGIN && (
          <GoogleLoginButton
            style={{
              ...styles.loginButton,
              padding: "4px 25px",
              pointerEvents: "none",
              position: "absolute",
              zIndex: 1,
            }}
            clientId={CONFIG.GOOGLE_CLIENT_ID}
            googleLoginText={intl.formatMessage({ id: "เข้าสู่ระบบด้วย Google" })}
            logoStyle={{ height: "40px" }}
            spanStyle={{ marginLeft: "-20px" }}
            shimmer
            onCallback={handleResponseGoogle}
            textStyle={{
              fontSize: "14px",
              margin: "auto",
            }}
          />
        )}
      </div>

      {CONFIG.PENTA_ACC_EMAIL_LOGIN && (
        <>
          <Divider style={{ margin: "2.15rem 0 1.35rem" }} horizontal>
            <div style={{ color: "#666", fontSize: "15px" }}>
              {intl.formatMessage({ id: "หรือ" })}
            </div>
          </Divider>

          <Form style={{ marginBottom: "1.4rem" }}>
            <Form.Group>
              <Form.Field width={16}>
                <label style={{ color: "#2B2B2B", fontSize: "15px", marginBottom: "0.5rem" }}>
                  {intl.formatMessage({ id: "ชื่อผู้ใช้งาน" })}
                </label>
                <Input
                  ref={(ref: any) => {
                    if (ref) {
                      ref.inputRef.current.style.borderRadius = "10px";
                    }
                  }}
                  size="large"
                  type="username"
                  value={props.AppInitializeSequence?.username}
                  fluid
                  onChange={handleUsernameChange}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field width={16}>
                <label style={{ color: "#2B2B2B", fontSize: "15px", marginBottom: "0.5rem" }}>
                  {intl.formatMessage({ id: "รหัสผ่าน" })}
                </label>

                <PasswordRecheck
                  borderRadius="10px"
                  password={props.AppInitializeSequence?.password}
                  placeholder=" "
                  size="large"
                  setPassword={(password) => {
                    props.setProp("AppInitializeSequence.password", password);
                  }}
                />
              </Form.Field>
            </Form.Group>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {/* <Button
              style={{
                backgroundColor: "var(--primary-theme-color)",
                borderRadius: "28px",
                fontSize: "15px",
                width: "68%",
              }}
              loading={isEmailLoading}
              size="large"
              fluid
              onClick={handleEmailSubmit}
            >
              ถัดไป
            </Button> */}
              <Button
                style={{
                  background: props.isMeHey ? "linear-gradient(90deg, #FDA0B8, #F9C26F)" : "none",
                  backgroundColor: props.isMeHey ? "none" : "var(--primary-theme-color)",
                  borderRadius: props.isMeHey ? "5px" : "28px",
                  color: "white",
                  fontSize: "15px",
                  width: "32.5%",
                }}
                loading={props.loadingLogin}
                size="large"
                fluid
                onClick={props.onLoginSubmit}
              >
                {intl.formatMessage({ id: "เข้าสู่ระบบ" })}
              </Button>
            </div>
            {/* <Form.Field error={!!emailError}>
              <label style={{ color: "#2B2B2B", fontSize: "15px", marginBottom: "0.5rem" }}>
                ลงชื่อเข้าใช้งานด้วย Email
              </label>

              <Input
                ref={(ref: any) => {
                  if (ref) {
                    ref.inputRef.current.style.borderRadius = "10px";
                  }
                }}
                error={!!emailError}
                placeholder="name@mail.com"
                size="large"
                type="email"
                value={email}
                fluid
                onChange={handleEmailChange}
              />

              {!!emailError && (
                <div style={styles.errorMessage}>
                  <span style={{ marginRight: "8px" }}>⚠</span>
                  <span>{emailError}</span>
                </div>
              )}
            </Form.Field> */}
          </Form>
        </>
      )}
    </>
  );
};

export default LoginForm;
